import { render } from "./BirdSoundStart.vue?vue&type=template&id=02f3ead2"
import script from "./BirdSoundStart.vue?vue&type=script&lang=js"
export * from "./BirdSoundStart.vue?vue&type=script&lang=js"

import "./BirdSoundStart.vue?vue&type=style&index=0&id=02f3ead2&lang=css"

import exportComponent from "/home/api.muzea.ro/wp-content/themes/szmm/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__